/**
 * Redux slice for managing forgot password state.
 * This slice handles the forgot password process, including the submission state,
 * password reset success, and any errors that may occur.
 */

import { createSlice } from '@reduxjs/toolkit';
import { COMPLETE_STATE, DEFAULT_STATE, FORBIDDEN_STATE, INTERNAL_SERVER_ERROR, PENDING_STATE } from '../../../../data/constants';
export const storeName = 'forgotPassword';
export const FORGOT_PASSWORD_SLICE_NAME = 'forgotPassword';
export const forgotPasswordInitialState = {
  status: DEFAULT_STATE,
  forgotPasswordFormData: {
    email: '',
    error: ''
  }
};
export const forgotPasswordSlice = createSlice({
  name: FORGOT_PASSWORD_SLICE_NAME,
  initialState: forgotPasswordInitialState,
  reducers: {
    forgotPassword: state => {
      state.status = PENDING_STATE;
    },
    forgotPasswordSuccess: state => {
      state.status = COMPLETE_STATE;
    },
    forgotPasswordForbidden: state => {
      state.status = FORBIDDEN_STATE;
    },
    forgotPasswordFailed: state => {
      state.status = INTERNAL_SERVER_ERROR;
    },
    forgotPasswordClearStatus: state => {
      state.status = DEFAULT_STATE;
    },
    forgotPasswordTokenInvalidFailure: (state, _ref) => {
      let {
        payload
      } = _ref;
      state.status = payload;
    },
    setForgotPasswordFormData: (state, _ref2) => {
      let {
        payload
      } = _ref2;
      state.forgotPasswordFormData = payload;
    }
  }
});
export const {
  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordForbidden,
  forgotPasswordFailed,
  forgotPasswordClearStatus,
  forgotPasswordTokenInvalidFailure,
  setForgotPasswordFormData
} = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;
//# sourceMappingURL=reducers.js.map